import { observer } from 'mobx-react';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { ApplicationRoutes } from '../../../../application/constants/routes';
import { UserSystemRoleModelPermissionMap } from '../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import LearningUnitPreviewPage from '../../../admin/page/LearningUnitPreviewPage';
import { LearningUserRatingPage } from '../../../admin/page/learningUserRatingPage/LearningUserRatingPage';
import { PassingPage } from '../../../admin/page/passing/Passing';
import { UnitPage } from '../../../admin/page/unit/UnitPage';
import { PageLoader } from '../../../design/page/PageLoader';
import { IPageWithLayoutProperties } from '../../../layout/page/IPageWithLayoutProperties';
import { LearningEntryPage } from './LearningEntryPage';

export const LearningPageShell = observer(({ layoutDomain }: IPageWithLayoutProperties) => {
  const isRoleReady = layoutDomain.ui.isBootLoading.value === false && Boolean(layoutDomain.ui.activeUser.entity?.id);
  const isAdmin = isRoleReady
    ? layoutDomain.userHaveAnyAccess([UserSystemRoleModelPermissionMap['global-allow-any']])
    : false;

  const renderLearningLoader = () => {
    return <PageLoader minHeight="100%" size={28} />;
  };

  const renderAdminOnly = (Component: any) => (routeProps: any) => {
    if (!isRoleReady) {
      return renderLearningLoader();
    }
    if (!isAdmin) {
      return <Redirect to={ApplicationRoutes.LearningRoot} push={false} />;
    }
    return <Component {...routeProps} layoutDomain={layoutDomain} />;
  };

  return (
    <Switch>
      <Route
        exact
        path={ApplicationRoutes.LearningRoot}
        render={() => <LearningEntryPage layoutDomain={layoutDomain} />}
      />
      <Route exact path={ApplicationRoutes.LearningUnitCreate} render={(props) => renderAdminOnly(UnitPage)(props)} />
      <Route exact path={ApplicationRoutes.LearningUnitEdit} render={(props) => renderAdminOnly(UnitPage)(props)} />
      <Route
        exact
        path={ApplicationRoutes.LearningUnitPreview}
        render={(props) => renderAdminOnly(LearningUnitPreviewPage)(props)}
      />
      <Route
        exact
        path={ApplicationRoutes.LearningUnitPassing}
        render={(routeProps) => <PassingPage {...routeProps} layoutDomain={layoutDomain} />}
      />
      <Route
        exact
        path={ApplicationRoutes.LearningUserRating}
        render={(props) => renderAdminOnly(LearningUserRatingPage)(props)}
      />
      <Redirect to={ApplicationRoutes.LearningRoot} />
    </Switch>
  );
});
